<template>
  <div class="consulting">
    <div class="Tit">热门咨询</div>
    <div class="ul">
      <li @click="detailsClick(item.id)" v-for="(item,index) in spnews.hot" :key="index">
        <div class="img fl"><img :src="item.cover" alt=""></div>
        <div class="p line-clamp-2 fr">{{item.describe}}</div>
      </li>
    </div>
    <div style="margin-top: 25px;" class="Tit">推荐资讯</div>
    <div class="ul">
      <li @click="detailsClick(item.id)" v-for="(item,index) in spnews.push" :key="index">
        <div class="img fl"><img :src="item.cover" alt=""></div>
        <div class="p line-clamp-2 fr">{{item.describe}}</div>
      </li>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      spnews: {
        type: Object
      }
    },
    methods: {
      detailsClick (id) {
        if (this.$parent.classifications) {
          this.$router.push({
            path: '/newsDetails',
            query: {
              id: id
            }
          })
        } else {
          this.$parent.id = id
          this.$parent.getData()
        }
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .consulting {
    width: 388px;
    overflow: hidden;

    .Tit {
      height: 25px;
      line-height: 25px;
      font-size: 18px;
      color: #5c5c5c;
      font-weight: bold;
    }

    .ul {
      overflow: hidden;
      width: 388px;

      li {
        height: 70px;
        width: 388px;
        overflow: hidden;
        margin-top: 20px;
        cursor: pointer;

        .img {
          width: 70px;
          height: 70px;
          border-radius: 5px;
          overflow: hidden;

          img {
            width: 70px;
          }
        }

        .p {
          height: 60px;
          line-height: 30px;
          width: 300px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/news/consulting/consulting.vue